module.exports = __webpack_public_path__ + "img/yingyezhizhao.a8ab8297.jpg";